import React from 'react'

const ShiftReplacementFailed = () => {
    return (
        <div>
            
        </div>
    )
}

export default ShiftReplacementFailed